import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { claimPriceForTargeting, useOfferPricing } from '../../useOfferPricing';

export default function OfferClaimPrice({ regionType, localTargets }) {
  const { pricing, error, loading, retry } = useOfferPricing();
  const price = claimPriceForTargeting(pricing, regionType, localTargets);
  return (
    <Box mt={1} aria-live="polite">
      {loading ? (
        <Typography variant="body2" color="text.secondary">Loading price...</Typography>
      ) : error ? (
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body2" color="text.secondary">Price is temporarily unavailable.</Typography>
          <Button size="small" onClick={() => { retry().catch(() => {}); }}>Retry price</Button>
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">
          {price == null ? 'Select targeting to see the price.' : `Estimated cost per click: $${price.toFixed(2)}`}
        </Typography>
      )}
    </Box>
  );
}
